export default __webpack_public_path__ + "static/clean-ingredients_experts_Kristi-Funk-8c849ffc930622878acbe8c08040aa1b.png";